// extracted by mini-css-extract-plugin
export default {"tbsTooltip":"TbsTooltip_tbsTooltip__eBUVm","icon":"TbsTooltip_icon__oV8R9","hidden":"TbsTooltip_hidden__scWB9"};